import Language from "@/layouts/components/Header/components/Language";
import i18n from "i18next";

export const fields = {
	// campaign_name: {
	//   label: i18n.t("condition.Campaign Name"),
	//   type: 'text',
	//   operators: ['like', 'not_like'],
	// },
	// adgroup_name: {
	//   label: i18n.t("condition.Ad Group Name"),
	//   type: 'text',
	//   operators: ['like', 'not_like'],
	// },
	// ad_name: {
	//   label: i18n.t("condition.Ad Name"),
	//   type: 'text',
	//   operators: ['like', 'not_like'],
	// },
	custom: {
		label: i18n.t("condition.Custom"),
		type: "!struct",
		subfields: {
			custom_incr_cpa: {
				label: i18n.t("condition.Increment CPA"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			custom_budget: {
				label: i18n.t("condition.Budget"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			},
			custom_spend_percent: {
				label: i18n.t("condition.Spend Percent"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"]
			}
		}
	},
	basic_data: {
		label: i18n.t("condition.Basic Data"),
		type: "!struct",
		subfields: {
			spend: {
				label: i18n.t("condition.Total cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The estimated total amount of money you've spent on your campaign, ad group or ad during its schedule."
			},
			cash_spend: {
				label: i18n.t("condition.Cost Charged by Cash"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The estimated amount of money you've spent on your campaign, ad group, or ad during its schedule charged by cash. (This metric can be required at the advertiser level only and lifetime, hourly breakdown are not supported.) Please notice that there may be a delay from 24h to 48h between when you were charged and when you can see it through the API."
			},
			voucher_spend: {
				label: i18n.t("condition.Cost Charged by Voucher"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The estimated amount of money you've spent on your campaign, ad group, or ad during its schedule charged by voucher. (This metric can be required at the advertiser level only and lifetime, hourly breakdown are not supported.) Please notice that there may be a delay from 24h to 48h between when you were charged and when you can see it through the API."
			},
			cpc: {
				label: i18n.t("condition.CPC"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average amount of money you've spent on a click."
			},
			cpm: {
				label: i18n.t("condition.CPM"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average amount of money you've spent per 1,000 impressions."
			},
			impressions: {
				label: i18n.t("condition.Impressions"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of times your ads were on screen."
			},
			clicks: {
				label: i18n.t("condition.Clicks"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of clicks on your ads."
			},
			ctr: {
				label: i18n.t("condition.CTR (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of times people saw your ad and performed a click."
			},
			reach: {
				label: i18n.t("condition.Reach"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of unique users who saw your ads at least once. This metric is estimated."
			},
			cost_per_1000_reached: {
				label: i18n.t("condition.Cost per 1,000 people reached"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost to reach 1,000 unique users. This metric is estimated."
			},
			conversion: {
				label: i18n.t("condition.Conversion"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The number of times your ad achieved an outcome, based on the secondary goal you selected. As one campaign may have a number of different secondary goals, this statistic is not supported for campaigns. Please go to ad groups or ads to view. (The total count is calculated based on the time each ad impression occurred.)"
			},
			cost_per_conversion: {
				label: i18n.t("condition.CPA"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The average amount of money you've spent on a conversion.(The total count is calculated based on the time each ad impression occurred.)"
			},
			conversion_rate: {
				label: i18n.t("condition.CVR (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The percentage of results you received out of all the clicks of your ads.(The total count is calculated based on the time each ad impression occurred.)"
			},
			real_time_conversion: {
				label: i18n.t("condition.Real-time Conversions"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The number of times your ad achieved an outcome, based on the objective and settings you selected. (The total count is based on when the conversion actually happened.)"
			},
			real_time_cost_per_conversion: {
				label: i18n.t("condition.Real-time CPA"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The average amount of money you've spent on a conversion. (The total count is based on when the conversion actually happened.)"
			},
			real_time_conversion_rate: {
				label: i18n.t("condition.Real-time CVR (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The percentage of results you received out of all the clicks of your ads. (The total count is based on when the conversion actually happened.)"
			},
			result: {
				label: i18n.t("condition.Result"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The number of times your ad achieved an outcome, based on the optimization goal you selected. As one campaign may have a number of different optimization goals, this statistic is not supported for campaigns. Please go to ad groups or ads to view the results. (The total count is calculated based on the time each ad impression occurred.)"
			},
			cost_per_result: {
				label: i18n.t("condition.Cost Per Result"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The average cost for each result from your ads. As one campaign may have a number of different optimization goals, this statistic is not supported for campaigns. Please go to ad groups or ads to view the cost per result. (The total count is calculated based on the time each ad impression occurred.)"
			},
			result_rate: {
				label: i18n.t("condition.Result Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The percentage of results you achieved out of all of the views/clicks on your ads. As one campaign may have a number of different optimization goals, this statistic is not supported for campaigns. Please go to ad groups or ads to view the result rate. (The total count is calculated based on the time each ad impression occurred.)"
			},
			real_time_result: {
				label: i18n.t("condition.Real-time Result"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The number of times your ad achieved an outcome, based on the optimization goal you selected. As a campaign may have different optimization goals, the total number of result is not supported in campaign section now ,Please go to the ad group section to view the result. (The total count is based on when the conversion actually happened.)"
			},
			real_time_cost_per_result: {
				label: i18n.t("condition.Real-time Cost Per Result"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"As a campaign may have different optimization goals, the total number of result is not supported in campaign section now, please go to the ad group section to view the cost per Result. (The total count is based on when the conversion actually happened.)"
			},
			real_time_result_rate: {
				label: i18n.t("condition.Real-time Result Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"As a campaign may have different optimization goals, the total number of result is not supported in campaign section now ,Please go to the ad group section to view the Result Rate. (The total count is based on when the conversion actually happened.)"
			},
			secondary_goal_result: {
				label: i18n.t("condition.Secondary Goal Result"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The number of times your ad achieved an outcome, based on the secondary goal you selected. As one campaign may have a number of different secondary goals, this statistic is not supported for campaigns. Please go to ad groups or ads to view. (The total count is calculated based on the time each ad impression occurred.)"
			},
			cost_per_secondary_goal_result: {
				label: i18n.t("condition.Cost per Secondary Goal Result"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The average cost for each secondary goal result from your adverts. As one campaign may have a number of different secondary goals, this statistic is not supported for campaigns. Please go to ad groups or ads to view. (The total count is calculated based on the time each ad impression occurred.)"
			},
			secondary_goal_result_rate: {
				label: i18n.t("condition.Secondary Goal Result Rate(%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip:
					"The percentage of secondary goal results you achieved out of all of the installs of your adverts. As one campaign may have a number of different secondary goals, this statistic is not supported for campaigns. Please go to ad groups or ads to view. The total count is calculated based on the time each ad impression occurred.."
			},
			frequency: {
				label: i18n.t("condition.Frequency"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average number of times each person saw your ad."
			}
		}
	},
	// video_play: {
	// 	label: i18n.t("condition.Video Play"),
	// 	type: "!struct",
	// 	subfields: {
	// 		video_play_actions: {
	// 			label: i18n.t("condition.Video Views"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of times your video starts to play. Replays will not be counted."
	// 		},
	// 		video_watched_2s: {
	// 			label: i18n.t("condition.2-Second Video Views"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of times your video played for at least 2 seconds. Replays will not be counted."
	// 		},
	// 		video_watched_6s: {
	// 			label: i18n.t("condition.6-Second Video Views"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip:
	// 				"The number of times your video played for at least 6 seconds, or completely played. Replays will not be counted."
	// 		},
	// 		average_video_play: {
	// 			label: i18n.t("condition.Video Average Watch Time Per Video View"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The average time your video was played per single video view, including any time spent replaying the video."
	// 		},
	// 		average_video_play_per_user: {
	// 			label: i18n.t("condition.Video Average Watch Time Per Person"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip:
	// 				"The average time your video was played per person, including any time spent replaying the video. This metric is estimated."
	// 		},
	// 		video_views_p25: {
	// 			label: i18n.t("condition.Video Views at 25%"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of times your video was played at 25% of its length. Replays will not be counted."
	// 		},
	// 		video_views_p50: {
	// 			label: i18n.t("condition.Video Views at 50%"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of times your video was played at 50% of its length. Replays will not be counted."
	// 		},
	// 		video_views_p75: {
	// 			label: i18n.t("condition.Video Views at 75%"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of times your video was played at 75% of its length. Replays will not be counted."
	// 		},
	// 		video_views_p100: {
	// 			label: i18n.t("condition.Video Views at 100%"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of times your video was played at 100% of its length. Replays will not be counted."
	// 		}
	// 	}
	// },
	// engagement: {
	// 	label: i18n.t("condition.Engagement"),
	// 	type: "!struct",
	// 	subfields: {
	// 		profile_visits: {
	// 			label: i18n.t("condition.Profile Visit"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of profile visits the ad drove during the campaign. This metric is only for Boosted TikToks."
	// 		},
	// 		profile_visits_rate: {
	// 			label: i18n.t("condition.Profile Visit Rate"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip:
	// 				"The rate of profile visits per impression the paid ad drove during the campaign. This metric is only for Boosted TikToks."
	// 		},
	// 		likes: {
	// 			label: i18n.t("condition.Paid Likes"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of likes your video creative received within 1 day of a user seeing a paid ad."
	// 		},
	// 		comments: {
	// 			label: i18n.t("condition.Paid Comments"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of comments your video creative received within 1 day of a user seeing a paid ad."
	// 		},
	// 		shares: {
	// 			label: i18n.t("condition.Paid Shares"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip: "The number of shares your video creative received within 1 day of a user seeing a paid ad."
	// 		},
	// 		follows: {
	// 			label: i18n.t("condition.Paid Follows"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip:
	// 				"The number of new followers that were gained within 1 day of a user seeing a paid ad. This metric is only for Boosted TikToks."
	// 		},
	// 		clicks_on_music_disc: {
	// 			label: i18n.t("condition.Clicks on music disc"),
	// 			type: "number",
	// 			operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
	// 			tooltip:
	// 				"The number of clicks on the official music in your Boosted TikTok ad during the campaign. Available only if you are on the allowlist for the Boosted TikTok feature."
	// 		}
	// 	}
	// },
	page_event: {
		label: i18n.t("condition.Page Event"),
		type: "!struct",
		subfields: {
			complete_payment_roas: {
				label: i18n.t("condition.Complete Payment ROAS"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total return on ad spend (ROAS) from complete payment events that are attributed to your ads."
			},
			complete_payment: {
				label: i18n.t("condition.Complete Payment"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of complete payment events."
			},
			cost_per_complete_payment: {
				label: i18n.t("condition.Complete Payment Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each complete payment event."
			},
			complete_payment_rate: {
				label: i18n.t("condition.Complete Payment Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of complete payment events out of all click events."
			},
			value_per_complete_payment: {
				label: i18n.t("condition.Value per Complete Payment"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from complete payment events."
			},
			total_complete_payment_rate: {
				label: i18n.t("condition.Total Complete Payment Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from complete payment events."
			},
			page_browse_view: {
				label: i18n.t("condition.Page Browse"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of page browse events."
			},
			cost_per_page_browse_view: {
				label: i18n.t("condition.Page Browse Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each page browse event."
			},
			page_browse_view_rate: {
				label: i18n.t("condition.Page Browse Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of page browse events out of all click events."
			},
			total_page_browse_view_value: {
				label: i18n.t("condition.Value per Page Browse"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from page browse events."
			},
			value_per_page_browse_view: {
				label: i18n.t("condition.Total Page Browse Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from page browse events."
			},
			button_click: {
				label: i18n.t("condition.Button Click"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of button click events."
			},
			cost_per_button_click: {
				label: i18n.t("condition.Button Click Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each button click event."
			},
			button_click_rate: {
				label: i18n.t("condition.Button Click Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of button click events out of all click events."
			},
			value_per_button_click: {
				label: i18n.t("condition.Value per Button Click"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from button click events."
			},
			total_button_click_value: {
				label: i18n.t("condition.Total Button Click Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from button click events."
			},
			online_consult: {
				label: i18n.t("condition.Online Consultation"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of online consultation events."
			},
			cost_per_online_consult: {
				label: i18n.t("condition.Online Consultation Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each online consultation event."
			},
			online_consult_rate: {
				label: i18n.t("condition.Online Consultation Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of online consultation events out of all click events."
			},
			value_per_online_consult: {
				label: i18n.t("condition.Value per Online Consultation"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from online consultation events."
			},
			total_online_consult_value: {
				label: i18n.t("condition.Total Online Consultation Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from online consultation events."
			},
			user_registration: {
				label: i18n.t("condition.User Registration"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of user registration events."
			},
			cost_per_user_registration: {
				label: i18n.t("condition.User Registration Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each user registration event."
			},
			user_registration_rate: {
				label: i18n.t("condition.User Registration Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of user registration events out of all click events."
			},
			value_per_user_registration: {
				label: i18n.t("condition.Value per User Registration"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from user registration events."
			},
			total_user_registration_value: {
				label: i18n.t("condition.Total User Registration Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from user registration events."
			},
			product_details_page_browse: {
				label: i18n.t("condition.Product Details Page Browse"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of product details page browse events."
			},
			cost_per_product_details_page_browse: {
				label: i18n.t("condition.Product Details Page Browse Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each product details page browse event."
			},
			product_details_page_browse_rate: {
				label: i18n.t("condition.Product Details Page Browse Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of product details page browse events out of all click events."
			},
			value_per_product_details_page_browse: {
				label: i18n.t("condition.Value per Product Details Page Browse"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from product details page browse events."
			},
			total_product_details_page_browse_value: {
				label: i18n.t("condition.Total Product Details Page Browse Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from product details page browse events."
			},
			web_event_add_to_cart: {
				label: i18n.t("condition.Add to Cart"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of add to cart events."
			},
			cost_per_web_event_add_to_cart: {
				label: i18n.t("condition.Add to Cart Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each add to cart event."
			},
			web_event_add_to_cart_rate: {
				label: i18n.t("condition.Add to Cart Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of add to cart events out of all click events."
			},
			value_per_web_event_add_to_cart: {
				label: i18n.t("condition.Value per Add to Cart"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from add to cart events."
			},
			total_web_event_add_to_cart_value: {
				label: i18n.t("condition.Total Add to Cart Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from add to cart events."
			},
			on_web_order: {
				label: i18n.t("condition.Place an Order"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of place an order events."
			},
			cost_per_on_web_order: {
				label: i18n.t("condition.Place an Order Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each place an order event."
			},
			on_web_order_rate: {
				label: i18n.t("condition.Place an Order Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of place an order events out of all click events."
			},
			value_per_on_web_order: {
				label: i18n.t("condition.Value per Place an Order"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from place an order events."
			},
			total_on_web_order_value: {
				label: i18n.t("condition.Total Place an Order Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from place an order events."
			},
			form: {
				label: i18n.t("condition.Form Submission"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of form submission events."
			},
			cost_per_form: {
				label: i18n.t("condition.Form Submission Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each form submission event."
			},
			form_rate: {
				label: i18n.t("condition.Form Submission Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of form submission events out of all click events."
			},
			value_per_form: {
				label: i18n.t("condition.Value per Form Submission"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from form submission events."
			},
			total_form_value: {
				label: i18n.t("condition.Total Form Submission Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from form submission events."
			},
			download_start: {
				label: i18n.t("condition.Download Button Click"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of download button click events."
			},
			cost_per_download_start: {
				label: i18n.t("condition.Download Button Click Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each download button click events."
			},
			download_start_rate: {
				label: i18n.t("condition.Download Button Click Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of download button click events out of all click events."
			},
			value_per_download_start: {
				label: i18n.t("condition.Value per Download Button Click"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from download button click events."
			},
			total_download_start_value: {
				label: i18n.t("condition.Total Download Button Click Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from download button click events."
			},
			initiate_checkout: {
				label: i18n.t("condition.Initiate Checkout"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of initiate checkout events."
			},
			cost_per_initiate_checkout: {
				label: i18n.t("condition.Initiate Checkout Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each initiate checkout event."
			},
			initiate_checkout_rate: {
				label: i18n.t("condition.Initiate Checkout Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of initiate checkout events out of all click events."
			},
			value_per_initiate_checkout: {
				label: i18n.t("condition.Value per Initiate Checkout"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from initiate checkout events."
			},
			total_initiate_checkout_value: {
				label: i18n.t("condition.Total Initiate Checkout Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from initiate checkout events."
			},
			add_billing: {
				label: i18n.t("condition.Add Billing"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of add billing events."
			},
			cost_per_add_billing: {
				label: i18n.t("condition.Add Billing Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each add billing event."
			},
			add_billing_rate: {
				label: i18n.t("condition.Add Billing Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of add billing events out of all click events."
			},
			value_per_add_billing: {
				label: i18n.t("condition.Value per Add Billing"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from add billing events."
			},
			total_add_billing_value: {
				label: i18n.t("condition.Total Add Billing Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from add billing events."
			},
			page_event_search: {
				label: i18n.t("condition.Search"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of search events."
			},
			cost_per_page_event_search: {
				label: i18n.t("condition.Search Cost"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each search event."
			},
			page_event_search_rate: {
				label: i18n.t("condition.Search Rate (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of search events out of all click events."
			},
			value_per_page_event_search: {
				label: i18n.t("condition.Value per Search"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from search events."
			},
			total_page_event_search_value: {
				label: i18n.t("condition.Total Search Value"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from search events."
			}
		}
	},
	on_site_event: {
		label: i18n.t("condition.Onsite Event"),
		type: "!struct",
		subfields: {
			onsite_shopping_roas: {
				label: i18n.t("condition.Complete Payment ROAS (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total return on ad spend (ROAS) from 'Complete Payment' events attributed to your TikTok ads."
			},
			onsite_shopping: {
				label: i18n.t("condition.Total Complete Payment (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of 'Complete Payment' events attributed to your TikTok ads."
			},
			cost_per_onsite_shopping: {
				label: i18n.t("condition.Cost per Complete Payment (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each 'Complete Payment' event attributed to your TikTok ads."
			},
			onsite_shopping_rate: {
				label: i18n.t("condition.Complete Payment Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of 'Complete Payment' events out of all click events attributed to your TikTok ads."
			},
			value_per_onsite_shopping: {
				label: i18n.t("condition.Value per Complete Payment (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from each 'Complete Payment' event attributed to your TikTok ads."
			},
			total_onsite_shopping_value: {
				label: i18n.t("condition.Total Complete Payment Value (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from 'Complete Payment' events attributed to your TikTok ads."
			},
			onsite_initiate_checkout_count: {
				label: i18n.t("condition.Total Initiate Checkout (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of 'Initiate Checkout' events attributed to your TikTok ads."
			},
			cost_per_onsite_initiate_checkout_count: {
				label: i18n.t("condition.Cost per Initiate Checkout (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each 'Initiate Checkout' event attributed to your TikTok ads."
			},
			onsite_initiate_checkout_count_rate: {
				label: i18n.t("condition.Initiate Checkout Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of 'Initiate Checkout' events out of all click events attributed to your TikTok ads."
			},
			value_per_onsite_initiate_checkout_count: {
				label: i18n.t("condition.Value per Initiate Checkout (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from each 'Initiate Checkout' event attributed to your TikTok ads."
			},
			total_onsite_initiate_checkout_count_value: {
				label: i18n.t("condition.Total Initiate Checkout Value (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from 'Initiate Checkout' events attributed to your TikTok ads."
			},
			onsite_on_web_detail: {
				label: i18n.t("condition.Total Product Details Page View (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of product detail page (PDP) view events attributed to your TikTok ads."
			},
			cost_per_onsite_on_web_detail: {
				label: i18n.t("condition.Cost per Product Details Page View (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each product detail page (PDP) view event attributed to your TikTok ads."
			},
			onsite_on_web_detail_rate: {
				label: i18n.t("condition.Product Details Page View Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of product detail page (PDP) view events out of all click events attributed to your TikTok ads."
			},
			value_per_onsite_on_web_detail: {
				label: i18n.t("condition.Value per Product Details Page View (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from each product detail page (PDP) event attributed to your TikTok ads."
			},
			total_onsite_on_web_detail_value: {
				label: i18n.t("condition.Total Product Details Page View Value (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from product detail page (PDP) view events attributed to your TikTok ads."
			},
			onsite_add_to_wishlist: {
				label: i18n.t("condition.Total Add To Wishlist (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of 'Add to Wishlist' events attributed to your TikTok ads."
			},
			cost_per_onsite_add_to_wishlist: {
				label: i18n.t("condition.Cost per Add To Wishlist (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each 'Add to Wishlist' event attributed to your TikTok ads."
			},
			onsite_add_to_wishlist_rate: {
				label: i18n.t("condition.Add To Wishlist Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of 'Add to Wishlist' events out of all click events attributed to your TikTok ads."
			},
			value_per_onsite_add_to_wishlist: {
				label: i18n.t("condition.Value per Add To Wishlist (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from each 'Add to Wishlist' event attributed to your TikTok ads."
			},
			total_onsite_add_to_wishlist_value: {
				label: i18n.t("condition.Total Add To Wishlist Value (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from 'Add to Wishlist' events attributed to your TikTok ads."
			},
			onsite_add_billing: {
				label: i18n.t("condition.Total Add Billing (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of 'Add Billing' events attributed to your TikTok ads."
			},
			cost_per_onsite_add_billing: {
				label: i18n.t("condition.Cost per Add Billing (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each 'Add Billing' event attributed to your TikTok ads."
			},
			onsite_add_billing_rate: {
				label: i18n.t("condition.Add Billing Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of 'Add Billing' events out of all click events attributed to your TikTok ads."
			},
			value_per_onsite_add_billing: {
				label: i18n.t("condition.Value per Add Billing (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from each 'Add Billing' event attributed to your TikTok ads."
			},
			total_onsite_add_billing_value: {
				label: i18n.t("condition.Total Add Billing Value (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from 'Add Billing' events attributed to your TikTok ads."
			},
			onsite_on_web_cart: {
				label: i18n.t("condition.Total Add to Cart (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of 'Add to Cart' events attributed to your TikTok ads."
			},
			cost_per_onsite_on_web_cart: {
				label: i18n.t("condition.Cost per Add to Cart (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each 'Add to Cart' event attributed to your TikTok ads."
			},
			onsite_on_web_cart_rate: {
				label: i18n.t("condition.Add to Cart Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of 'Add to Cart' events out of all click events attributed to your TikTok ads."
			},
			value_per_onsite_on_web_cart: {
				label: i18n.t("condition.Value per Add to Cart (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from each 'Add to Cart' event attributed to your TikTok ads."
			},
			total_onsite_on_web_cart_value: {
				label: i18n.t("condition.Total Add to Cart Value (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from 'Add to Cart' events attributed to your TikTok ads."
			},
			onsite_form: {
				label: i18n.t("condition.Total Form Submission (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of form submission events attributed to your TikTok ads."
			},
			cost_per_onsite_form: {
				label: i18n.t("condition.Cost per Form Submission (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each form submission event attributed to your TikTok ads."
			},
			onsite_form_rate: {
				label: i18n.t("condition.Form Submission Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of form submission events out of all click events attributed to your TikTok ads."
			},
			value_per_onsite_form: {
				label: i18n.t("condition.Value per Form Submission (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average value returned from each form submission event attributed to your TikTok ads."
			},
			total_onsite_form_value: {
				label: i18n.t("condition.Total Form Submission Value (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The total value returned from form submission events attributed to your TikTok ads."
			},
			onsite_download_start: {
				label: i18n.t("condition.Total App Store Click (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of app store click events attributed to your TikTok ads."
			},
			cost_per_onsite_download_start: {
				label: i18n.t("condition.Cost per App Store Click (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each app store click event attributed to your TikTok ads."
			},
			onsite_download_start_rate: {
				label: i18n.t("condition.App Store Click Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of app store click events out of all click events attributed to your TikTok ads."
			},
			ix_page_view_count: {
				label: i18n.t("condition.Page Views (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of page view events attributed to your TikTok ads."
			},
			cost_per_ix_page_view_count: {
				label: i18n.t("condition.Cost per Page Views (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each page view event attributed to your TikTok ads."
			},
			ix_page_view_count_rate: {
				label: i18n.t("condition.Page Views Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of page view events out of all click events attributed to your TikTok ads."
			},
			// ix_button_click_count: {
			// 	label: i18n.t("condition.Call-to-Action Button Clicks (Instant Experience)"),
			// 	type: "number",
			// 	operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
			// 	tooltip: "The number of call to action button click events attributed to your TikTok ads."
			// },
			cost_per_ix_button_click_count: {
				label: i18n.t("condition.Cost per Call-to-Action Button Clicks (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each call to action button click event attributed to your TikTok ads."
			},
			ix_button_click_count_rate: {
				label: i18n.t("condition.Call-to-Action Button Clicks Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of call to action button click events out of all click events attributed to your TikTok ads."
			},
			ix_product_click_count: {
				label: i18n.t("condition.Product Clicks (Instant Experience)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The number of product click events attributed to your TikTok ads."
			},
			cost_per_ix_product_click_count: {
				label: i18n.t("condition.Cost per Product Clicks (Onsite)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The average cost of each product click event attributed to your TikTok ads."
			},
			ix_product_click_count_rate: {
				label: i18n.t("condition.Product Clicks Rate (Onsite) (%)"),
				type: "number",
				operators: ["equal", "not_equal", "less", "less_or_equal", "greater", "greater_or_equal"],
				tooltip: "The percentage of product click events out of all click events attributed to your TikTok ads."
			}
		}
	}
};
